<template>
  <div class="c8-explanation__content">
    <p>1. 路珠图展示近期每期的开奖结果，请从左到右、自上而下查看路珠图，当连续开出的同一形态中断时，则另起一列显示</p>
    <p>2. 表格最右一列为最新一期结果</p>
  </div>
</template>

<script>
export default {
  name: 'PK10WebLongHuLuJhu' // pk10 龍虎路珠
}
</script>
